<template>
  <div :class="{'_full': isFull}" class="ui-accordion">
    <div v-if="mainTitle" class="ui-accordion__header">
      <p class="ui-accordion__title h2-semibold">{{ mainTitle }}</p>
    </div>
    <div class="ui-accordion__body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "Accordion",
  props: {
    mainTitle: {
      type: String,
      default: "",
    },
    isFull: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onOpen() {

    },
    onClose() {

    },
    toggleBody() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>
